import { CookieOffOutlineIcon } from './CookieOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4355ECEC-E157-4BC8-AF80-45FAC597F188
 * name cookie-off-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-off-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitOffOutlineIcon = CookieOffOutlineIcon;
export default BiscuitOffOutlineIcon